export const ensureBearerToken = accessToken => {
  const bearerPrefix = "Bearer ";
  if (typeof accessToken === "string" && !accessToken.startsWith(bearerPrefix)) {
    return bearerPrefix + accessToken;
  }
  return accessToken;
};

export const parseJwt = token => {
  try {
    // Remove 'Bearer ' prefix if present
    const base64Url = token.startsWith("Bearer ")
      ? token.slice(7).split(".")[1]
      : token.split(".")[1];

    // Replace URL-safe characters and decode Base64
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const decodedPayload = JSON.parse(atob(base64)); // Decode Base64 and parse JSON
    return decodedPayload; // Return the extracted values
  } catch (error) {
    return null;
  }
};
